/**
 * Catch-up completion events (byte-identical in owner + reception).
 *
 * useSyncVersion reports here; instrumentation-client.js forwards to each repo's perfMetrics, so the
 * shared hook needs no repo-specific observability import.
 */

/** @typedef {{ reason: string, durationMs: number, timedOut: boolean }} CatchUpInfo */

/** @type {Set<(info: CatchUpInfo) => void>} */
const listeners = new Set();

/** @param {(info: CatchUpInfo) => void} callback @returns {() => void} unsubscribe */
export function onCatchUpComplete(callback) {
  if (typeof callback !== "function") return () => {};
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

/** @param {CatchUpInfo} info */
export function reportCatchUpComplete(info) {
  for (const fn of Array.from(listeners)) {
    try {
      fn(info);
    } catch {
      /* observability must never break catch-up */
    }
  }
}

export function __resetCatchUpEventsForTests() {
  listeners.clear();
}
